import { QLog, QMessageMetadata, QTask, SelectOption } from '@qwealth/qdata';
import { CalendarEvent } from '../data-layer/event';

export type Activity = QTask | QLog | CalendarEvent | QMessageMetadata;

export const ACTIVITY_TYPE_EVENTS = 'events';
export const ACTIVITY_TYPE_EMAILS = 'emails';
export const ACTIVITY_TYPE_TASKS = 'tasks';
export const ACTIVITY_TYPE_LOGS = 'logs';
export const ACTIVITY_TYPE_WORKFLOWS = 'workflows';
export const ActivityTypes = [ACTIVITY_TYPE_EVENTS, ACTIVITY_TYPE_EMAILS, ACTIVITY_TYPE_TASKS, ACTIVITY_TYPE_LOGS, ACTIVITY_TYPE_WORKFLOWS] as const;
export type ActivityType = (typeof ActivityTypes)[number];

export const ACTIVITY_TYPE_OPTIONS: SelectOption<ActivityType>[] = [
  { label: 'Events', value: 'events' },
  { label: 'Emails', value: 'emails' },
  { label: 'Tasks', value: 'tasks' },
  { label: 'Call Logs', value: 'logs' },
];

export const MODAL_MODE_VIEW = 'View';
export const MODAL_MODE_EDIT = 'Edit';
export const MODAL_MODE_ADD = 'Add';
export const MODAL_MODE_OPTIONS = [MODAL_MODE_VIEW, MODAL_MODE_EDIT, MODAL_MODE_ADD] as const;
export type ModalModeOptions = (typeof MODAL_MODE_OPTIONS)[number];

export const PAGE_MODE_VIEW = 'View';
export const PAGE_MODE_EDIT = 'Edit';
export const PAGE_MODE_ADD = 'Add';
export const PAGE_MODE_IDLE = 'Idle';
export const PAGE_MODE_OPTIONS = [PAGE_MODE_IDLE, PAGE_MODE_VIEW, PAGE_MODE_EDIT, PAGE_MODE_ADD] as const;
export type PageModeOptions = (typeof PAGE_MODE_OPTIONS)[number];

export const TASK_TAB_COMMENTS = 'Comments';
export const TASK_TAB_QNOTES = 'QNotes';
export const TASK_TAB_ATTACHMENTS = 'Attachments';
export const TASK_TABS_OPTIONS = [TASK_TAB_COMMENTS, TASK_TAB_QNOTES, TASK_TAB_ATTACHMENTS] as const;
export type TaskTabOptions = (typeof TASK_TABS_OPTIONS)[number];

export const FORM_STATUS_SAVING = 'Saving';
export const FORM_STATUS_SAVED = 'Saved';
export const FORM_STATUS_ERROR = 'Error';
export const FORM_STATUS_IDLE = 'Idle';
export const FORM_STATUS_OPTIONS = [FORM_STATUS_IDLE, FORM_STATUS_SAVING, FORM_STATUS_SAVED, FORM_STATUS_ERROR] as const;
export type FormStatusOptions = (typeof FORM_STATUS_OPTIONS)[number];

export const ACTION_CONFIRMATION_EDIT = 'Edit';
export const ACTION_CONFIRMATION_DELETE = 'Delete';
export const ACTION_CONFIRMATION_OPTIONS = [ACTION_CONFIRMATION_EDIT, ACTION_CONFIRMATION_DELETE] as const;
export type ActionConfirmationOptions = (typeof ACTION_CONFIRMATION_OPTIONS)[number];

export type QTaskComment = {
  content: string;
  noteType: 'comment';
  readonly owners?: string[];
  taskId: number;
  readonly postDatetime?: string;
  readonly author?: string;
  readonly uuid?: string;
  readonly firstName?: string;
  readonly lastName?: string;
};

export const PANEL_TAB_TASKS = 'Tasks';
export const PANEL_TAB_CALL_LOGS = 'Calls';
export const PANEL_TAB_TICKETS = 'Tickets';
export const PANEL_TAB_BIRTHDAYS = 'Birthdays';
export const PANEL_TAB_WORKFLOWS = 'Workflows';

export const PANEL_TAB_TASK_PREVIEW = 'Task Preview';
export const PANEL_TAB_ADD_TASK = 'Add Task';
export const PANEL_TAB_CALL_LOG_PREVIEW = 'Call Log Preview';
export const PANEL_TAB_ADD_CALL_LOG = 'Add Call Log';
export const PANEL_TAB_TICKET_PREVIEW = 'Ticket Preview';
export const PANEL_TAB_CREATE_TICKET = 'Create Ticket';
export const PANEL_TAB_ASSIGNED_WORKFLOW_PREVIEW = 'Workflow Preview';
export const PANEL_TAB_ASSIGN_WORKFLOW_TEMPLATE = 'Assign Workflow Template';

export const PANEL_TAB_IDLE = 'Idle';

export const QFEED_TABS_LEFT_PANEL_OPTIONS = [
  PANEL_TAB_TASKS,
  PANEL_TAB_WORKFLOWS,
  PANEL_TAB_CALL_LOGS,
  PANEL_TAB_TICKETS,
  PANEL_TAB_BIRTHDAYS,
] as const;
export const QFEED_TABS_RIGHT_PANEL_OPTIONS = [
  PANEL_TAB_TASK_PREVIEW,
  PANEL_TAB_ADD_TASK,
  PANEL_TAB_CALL_LOG_PREVIEW,
  PANEL_TAB_ADD_CALL_LOG,
  PANEL_TAB_TICKET_PREVIEW,
  PANEL_TAB_CREATE_TICKET,
  PANEL_TAB_ASSIGNED_WORKFLOW_PREVIEW,
  PANEL_TAB_ASSIGN_WORKFLOW_TEMPLATE,
  PANEL_TAB_IDLE,
] as const;

export type QFeedTabLeftPanelOptions = (typeof QFEED_TABS_LEFT_PANEL_OPTIONS)[number];
export type QFeedTabRightPanelOptions = (typeof QFEED_TABS_RIGHT_PANEL_OPTIONS)[number];

export const LOG_TYPES = ['Administration', 'Cashiering', 'Financial Planning', 'Life Event', 'Other', 'Portfolio Management'];
